export default "__VITE_ASSET__BNG2NJGl__"